export default __webpack_public_path__ + "static/media/web_prestadores.13298a06.jpg";